// userService.js
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig';

// Function to fetch all users from Firestore
export const fetchAllUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'users'));
    const users = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // console.log('Fetched Users:', users);
    return users;
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
};
